<div class="is-flex is-space-between gap-16">
  @for (day of forecast().forecastDays; track day.day_ts) {

    <div class="card is-flex is-column is-align-center gap-16 is-flex-grow-1">
      <div class="is-flex is-column is-align-center gap-4">
        <app-text class="is-family-semiBold text-12 text-grey-70">{{ getDay(day.day_ts) }}</app-text>
        <app-weather-forecast-icon [symbol]="day.weather_symbol_day" width="60" height="60"></app-weather-forecast-icon>
        <div class="is-flex text-grey-70">
          <app-text class="is-family-bold text-22">{{ day.max_temp | toUserUnit : EnumMeasureTypes.TEMPERATURE | toDisplayValue : EnumMeasureTypes.TEMPERATURE }}</app-text>
          <app-text class="text-18 is-family-semiBold" unit [measureType]="EnumMeasureTypes.TEMPERATURE"></app-text>
        </div>
        <div class="is-flex text-grey-50">
          <app-text>{{ day.min_temp | toUserUnit : EnumMeasureTypes.TEMPERATURE | toDisplayValue : EnumMeasureTypes.TEMPERATURE }}</app-text>
          <app-text unit [measureType]="EnumMeasureTypes.TEMPERATURE"></app-text>
        </div>
      </div>
      <div class="is-flex is-column gap-8">
        <div class="is-flex is-space-between text-grey-50">
          <app-icon class="text-arctic-blue" name="weather-heavy-rain"></app-icon>
          <div class="is-flex text-12 is-family-semiBold">
            <app-text>{{ day.rain | toUserUnit : EnumMeasureTypes.SUM_RAIN | toDisplayValue : EnumMeasureTypes.SUM_RAIN }}</app-text>
            &nbsp;
            <app-text unit [measureType]="EnumMeasureTypes.SUM_RAIN"></app-text>
          </div>
        </div>
        <div class="is-flex is-space-between">
          <app-icon [style.color]="'#BBDAFF'" name="weather-wind"></app-icon>
          <div class="is-flex text-12 is-family-semiBold text-grey-50">
            <app-text>{{ day.windstrength | toUserUnit : EnumMeasureTypes.WIND_STRENGTH | toDisplayValue : EnumMeasureTypes.WIND_STRENGTH }}</app-text>
            &nbsp;
            <app-text unit [measureType]="EnumMeasureTypes.WIND_STRENGTH"></app-text>
          </div>
        </div>
        <div class="is-flex is-space-between">
          <app-icon class="text-yellow" name="sun"></app-icon>
          <div class="is-flex text-12 is-family-semiBold text-grey-50">
            <app-text>{{ day.sun }}</app-text>
            &nbsp;
            <app-text>h</app-text>
          </div>
        </div>
        <div class="is-flex is-space-between">
          <app-icon class="text-grey-70" name="uv"></app-icon>
          <div class="is-flex text-12 is-family-semiBold text-grey-50">
            <app-text>{{ day.uv }}</app-text>
          </div>
        </div>
      </div>
    </div>

  }
</div>
